module.exports = __webpack_public_path__ + "static/media/InstantTransfer.b728ffec.svg";